
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class RadioGroupEditor extends Vue {
  @Prop({ required: true })
  value!: any | null;

  radios: { label: string, checked: boolean }[] = [];

  clearSelection(): void {
    this.radios.forEach(e => e.checked = false);
  }

  notifyChange(): void {
    //TODO user stringify for now, when the app is able to handle any-typed data without crashing, then remove the stringification and save the array as is
    const value = JSON.stringify(this.radios);
    this.$emit('input', value);
  }

  //functions
  selectRadio(index: number, checked: boolean): void {
    this.radios.forEach(e => e.checked = false);
    this.radios[index].checked = checked;
  }

  @Watch('value', { immediate: true, deep: true })
  onValueChanged(): void {
    if (Array.isArray(this.value)) {
      this.radios = this.value;
    } else if (typeof this.value === 'string') {
      let parsed: { label: string, checked: boolean }[] = [];
      try {
        parsed = JSON.parse(this.value);
      } catch (_) {
      }
      if (!Array.isArray(parsed)) {
        parsed = [];
      }
      this.radios = parsed;
    } else {
      this.radios = [];
    }
  }
};

